import { useFormContext } from 'react-hook-form';
import { NumberSelectField } from '@views/register/history/history-fields';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistorySocialFormValues, IHistorySocialModel } from '@/types/history/history-social';
import FieldError from '@components/field-error';

interface IProps {
    model: IHistorySocialModel;
    t: TLocalize;
}

/** Tobacco follow-ups. Only rendered when tobacco use was reported during screening. */
const TobaccoSection = ({ model, t }: IProps) => {
    const {
        register,
        formState: { errors },
    } = useFormContext<IHistorySocialFormValues>();

    const selectNumber = t('DashLabel_SelectNumber', 'Select Number');
    const selectFrequency = t('DashLabel_SelectFrequency', 'Select Frequency');

    return (
        <>
            <NumberSelectField
                name="tobaccoYears"
                label={t('DashLabel_HowManyYearsDidYouUseTobacco', 'How many years did you use tobacco')}
                max={80}
                placeholder={t('DashLabel_SelectYears', 'Select Years')}
            />

            <div className="form-group">
                <label className="control-label col-xs-12">
                    <span className="form-required">*</span>{' '}
                    {t('DashLabel_HowManyPacksCans', 'How many packs/cans')}:
                </label>
                <div className="col-xs-6">
                    <div className="input-group">
                        <select className="form-control" {...register('tobaccoPacks')}>
                            <option value="">{selectNumber}</option>
                            {Array.from({ length: 20 }, (_, i) => i + 1).map((n) => (
                                <option key={n} value={n}>
                                    {n}
                                </option>
                            ))}
                        </select>
                        <span className="input-group-addon">
                            <div>{t('DashLabel_PacksCans', 'packs/cans')}</div>
                        </span>
                    </div>
                    <FieldError message={errors.tobaccoPacks?.message} />
                </div>
                <div className="col-xs-6">
                    <select className="form-control" {...register('tobaccoFrequency')}>
                        <option value="">{selectFrequency}</option>
                        {model.frequencyOptions.map((o) => (
                            <option key={o.value} value={o.value}>
                                {o.label}
                            </option>
                        ))}
                    </select>
                    <FieldError message={errors.tobaccoFrequency?.message} />
                </div>
            </div>
        </>
    );
};

export default TobaccoSection;
